import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { ToolbarItems } from './ToolbarItems';
export var ToolbarContent = styled.div.withConfig({
  displayName: "Toolbar__ToolbarContent",
  componentId: "sc-n4wer-0"
})(["display:flex;align-items:center;flex-wrap:wrap;margin-top:15px;", ";"], maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    justify-content: space-between;\n  "]))));
export var Toolbar = function Toolbar(props) {
  return React.createElement(ToolbarContent, null, React.createElement(ToolbarItems, props));
};